/* tslint:disable */
/* eslint-disable */
export enum OutletMode {
  Qr = 'QR',
  Pickup = 'PICKUP',
  Delivery = 'DELIVERY',
  PickupDelivery = 'PICKUP_DELIVERY',
  Eatin = 'EATIN'
}
